var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketbgelement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:red;}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -180.18,
    y1: 591.67,
    x2: 321.2,
    y2: 292.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#e73900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffff9e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -203.98,
    y1: 551.8,
    x2: 297.4,
    y2: 252.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -21.7,
    y1: 332.31,
    x2: 522.77,
    y2: 116.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -9.65,
    y1: 362.76,
    x2: 534.82,
    y2: 147.33,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 17.26,
    y1: 430.78,
    x2: 561.73,
    y2: 215.35,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -184.09,
    y1: 585.12,
    x2: 317.29,
    y2: 285.86,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.75,364.61a15.51,15.51,0,0,0,2.26,2.87c2.42,1.85,2.57,4.06,2,6.86a81.54,81.54,0,0,1-6.06,16.93,113.93,113.93,0,0,1-28.56,38.45c-8.68,7.61-17.7,14.84-26.44,22.38S74.43,467.48,65.7,475.18L64,476.67a6,6,0,0,1,.43-1.42c11.5-14.67,20-31,27.3-48.09,5-11.72,5.07-11.68,14.08-20.51L146,367.22C146.67,366.52,147.42,365.85,148.75,364.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.28,336.18l13,13L81.4,399.78l-.74-1.06c-6.27,4.88-12.42,9.75-18.68,14.5-9,6.88-18.16,13.7-28.06,19.35-2.64,1.51-5.45,2.71-8.23,4a6.1,6.1,0,0,1-3.35.41,5.51,5.51,0,0,1,1-.91c7.13-3.95,13-9.44,18.53-15.3,13.39-14.14,24.55-30,35.93-45.77,3.9-5.39,7.9-10.71,11.78-16.12A50.88,50.88,0,0,1,104,345.19c4.63-2.88,9.42-5.48,14.16-8.18A16,16,0,0,1,120.28,336.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M232.83,376.09l-47.26-48,58.05-56.93L229,256.17a2.91,2.91,0,0,0-.47,0,.48.48,0,0,0-.26.06,4.49,4.49,0,0,0-.65.5q-28.34,27.76-56.65,55.55a4.91,4.91,0,0,1-.63.28l-47.08-47.94c1.34-2.63,2.59-5.09,3.86-7.54,17.92-34.38,38.69-66.88,63.35-96.84,30.17-36.62,64.94-68,105.56-92.76A367.54,367.54,0,0,1,334.41,47c.92-.42,1.86-.81,3.1-1.35L455.22,166.62c-.46,1-.87,2-1.34,3a382.71,382.71,0,0,1-57.09,85.88c-31.76,36.29-68.91,66.1-109.91,91.27-16.64,10.2-33.77,19.5-51.31,28.06C234.74,375.24,233.9,375.61,232.83,376.09Zm30.43-186.7a48,48,0,0,0,7.5,26.56c10.52,16.28,29.76,24.42,49.62,20.92,26.82-4.72,48.27-29,46.91-57.8-.65-13.9-6.19-25.62-17-34.51-12.39-10.2-26.7-12.92-42.22-9.75C282.63,140,263.39,163.51,263.26,189.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.2,318.71c-8.3,8.15-16.38,16.09-24.55,24.1l-35.79-36.34c4.64-11,9.75-22.34,15.43-33.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155.11,358.1l24.36-23.92,44.73,45.54a14.63,14.63,0,0,1-1.68,1c-10,4.35-20,8.63-30,13.06-1.9.84-3,.35-4.33-1-4.34-4.54-9.09-8.73-13.11-13.54-6-7.17-12.95-13.37-19.31-20.16A11.31,11.31,0,0,1,155.11,358.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M485.67,17.63c-.67,2-2.15,2.5-3.51,2.9a111.19,111.19,0,0,1-12.56,3.32c-13.2,2.23-26.42,4.4-39.68,6.18-13.82,1.86-27.69,3.33-41.56,4.79-8.91.94-17.85,1.55-26.78,2.3a3.05,3.05,0,0,1-2-.46c1-.4,1.94-.84,2.93-1.18a379,379,0,0,1,53.63-14.74A298.6,298.6,0,0,1,475.35,15,38.32,38.32,0,0,1,483,16.1,10,10,0,0,1,485.67,17.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.52,426.11c-16.44,15.71-32.86,30.95-50.21,45.16-9.8,8-16.61,12.72-20,13.77,2.37-3,5.5-5.19,8.08-8s5.26-5.45,7.81-8.25,5.16-5.79,7.66-8.75,4.95-6,7.36-9,4.64-6,6.9-9,4.59-6.26,6.83-9.42,4.31-6.22,6.45-9.35,4.31-6.37,6.67-9.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.26,189.39c.13-25.88,19.37-49.38,44.83-54.58,15.52-3.17,29.83-.45,42.22,9.75,10.79,8.89,16.33,20.61,17,34.51,1.36,28.76-20.09,53.08-46.91,57.8-19.86,3.5-39.1-4.64-49.62-20.92A48,48,0,0,1,263.26,189.39ZM319.2,142c-2.2.22-4.41.36-6.6.68-22.8,3.27-41.83,24.59-40.81,48.86A38.75,38.75,0,0,0,309.9,229c16.31.25,29.39-6.52,39.23-19.3,8.29-10.76,11.6-23.06,8.89-36.53C354.25,154.5,338.54,142.07,319.2,142Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M319.2,142c19.34.11,35.05,12.54,38.82,31.23,2.71,13.47-.6,25.77-8.89,36.53-9.84,12.78-22.92,19.55-39.23,19.3a38.75,38.75,0,0,1-38.11-37.52c-1-24.27,18-45.59,40.81-48.86C314.79,142.32,317,142.18,319.2,142Zm-39.39,46.3c0,.65.07,1.29.09,1.94A32.33,32.33,0,0,0,310,221a38.56,38.56,0,0,0,37.56-22.92c5.3-12.28,4.83-24.31-3.4-35.14-8.35-11-19.91-14.52-33.28-12.09C293.2,154,279.73,170.41,279.81,188.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.81,188.26c-.08-17.85,13.39-34.23,31.05-37.44,13.37-2.43,24.93,1.09,33.28,12.09,8.23,10.83,8.7,22.86,3.4,35.14A38.56,38.56,0,0,1,310,221,32.33,32.33,0,0,1,279.9,190.2C279.88,189.55,279.84,188.91,279.81,188.26Zm8.52-.27a23.94,23.94,0,0,0,24,24.44c14.79.11,28.14-11.68,29.85-26.38,1.49-12.85-6.74-24.39-19.13-26.82C305.74,155.82,288.44,170.14,288.33,188Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M288.33,188c.11-17.85,17.41-32.17,34.75-28.76,12.39,2.43,20.62,14,19.13,26.82-1.71,14.7-15.06,26.49-29.85,26.38A23.94,23.94,0,0,1,288.33,188Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketbgelement);
export default __webpack_public_path__ + "static/media/rocket bg element.a6f2dfc725597102ea1c719fd283b0f6.svg";
export { ForwardRef as ReactComponent };